import { classEnum } from "./base";

export const ProvisionItemStatusEnum = new (class extends classEnum([
    {
        label: "PINJAM",
        value: "L",
    },
    {
        label: "SEWA",
        value: "R",
    },
    {
        label: "BELI",
        value: "B",
    },
    {
        label: "INFRASTRUKTUR",
        value: "I",
    },
]) {
    public get valuesClient() {
        return this.values.filter((v) => v !== "I");
    }

    public get selectClient() {
        return this.select.filter((v) => v.value !== "I");
    }

    public get ValuesClient(): this["valuesClient"][number] {
        throw new Error("ValuesClient can't be used as a value");
    }
})();

export namespace ProvisionItemStatusEnum {
    export type Labels = (typeof ProvisionItemStatusEnum)["labels"][number];
    export type Values = (typeof ProvisionItemStatusEnum)["values"][number];
    export type ValuesClient = (typeof ProvisionItemStatusEnum)["valuesClient"][number];
}
